import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found" className="pt-40 pb-24 bg-[#FAFAFA] min-h-[80vh] grid place-items-center">
      <div className="text-center max-w-lg px-6">
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#B8860B] mb-4">
          404 · Bulunamadı
        </div>
        <div className="font-serif-display text-[120px] md:text-[180px] leading-none text-[#1E1E1E]">
          404
        </div>
        <h1 className="mt-6 font-serif-display text-3xl text-[#1E1E1E]">
          Aradığınız yüzey bu adreste değil.
        </h1>
        <p className="mt-3 text-[#666]">
          Sayfa kaldırılmış veya adres yanlış girilmiş olabilir.
        </p>
        <Link to="/" className="btn-gold mt-10 inline-flex">
          Ana Sayfaya Dön <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
